const defaultState = function () {
  return {
    mode: 0,
    returnList: false,
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    currentPage: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchConditions: {
      customerType: {
        type: 'MultiSelector',
        title: '権限タイプ',
        property: '',
        display: false,
        value: '',
        options: [
          { code: 1, name: 'サイト' },
          { code: 2, name: 'ロール' }
        ]
      }
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getDefaultState: defaultState
}



// WEBPACK FOOTER //
// ./src/store/pages/pointSetting.js